import React from 'react';
import { Pagination } from '../../../../components/pagination';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import './extension-statistics-style.scss';
const NoStatistics = ({ cn }) => {
    return (<div className={cn('no-content-wrapper')}>
      <h2 className={cn('no-content-header')}>
        <FormattedMessage id="no-statistics" defaultMessage="No Statistics"/>
      </h2>
    </div>);
};
export const StatisticsTable = ({ cn, statistics, limit, currentPage, onPageChange, isStatisticsItems }) => isStatisticsItems ? (<div className="content-wrapper">
      <table className={classnames('table', 'extension-statistics-table')}>
        <thead>
          <tr>
            <th>Date</th>
            <th>User</th>
            <th>Institution</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          {statistics.list.map(item => {
        return (<tr key={item.id}>
                <td>{new Date(item.timestamp).toLocaleDateString()}</td>
                <td>
                  {!!item.userFirstName &&
                !!item.userLastName &&
                `${item.userFirstName} ${item.userLastName}`}
                </td>
                <td>{!!item.institutionName && item.institutionName}</td>
                <td>{item.amount}</td>
              </tr>);
    })}
        </tbody>
      </table>
      <Pagination totalItems={statistics.total} limitPerPage={limit} currentPage={currentPage} onChange={onPageChange}/>
    </div>) : (<NoStatistics cn={cn}/>);
